<template>
  <div>
    <div class="filter-wrapper">
      <div class="filter-options">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field v-model="title" label="Tên công việc" clearable dense outlined hide-details="auto" />
          </v-col>
          <v-col cols="12" md="4">
            <AutocompleteExcludeTask
              :syncedValue.sync="creatorId"
              item-text="name"
              clear-icon="mdi-close"
              outlined
              dense
              deletable-chips
              label="Người giao việc"
              hide-details
              :displaySubjectGroup="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <AutocompleteExcludeTask
              :syncedValue.sync="receiverId"
              item-text="name"
              clear-icon="mdi-close"
              outlined
              dense
              deletable-chips
              label="Người nhận việc"
              hide-details
              :displaySubjectGroup="true"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-select
              v-model="status"
              :items="statusOptions"
              item-text="text"
              item-value="value"
              label="Trạng thái"
              dense
              outlined
              clearable
              hide-details="auto"
            />
          </v-col>
          <v-col cols="12" md="4">
            <DateIOSPicker
              label="Hạn hoàn thành từ ngày"
              outlined
              dense
              outline
              :date.sync="dateFrom"
              clearable
              :rules="[$rules.date]"
            />
          </v-col>
          <v-col cols="12" md="4" class="mb-6">
            <DateIOSPicker
              label="Hạn hoàn thành đến ngày"
              outlined
              dense
              outline
              :date.sync="dateTo"
              clearable
              :rules="[$rules.date]"
            />
          </v-col>
        </v-row>
      </div>
      <div class="filter-submit">
        <v-btn class="search-button" height="40" outlined @click="applyFilters">TÌM KIẾM</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import AutocompleteExcludeTask from '@/components/basic/input/AutocompleteExcludeTask'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'

export default {
  components: {
    DateIOSPicker,
    AutocompleteExcludeTask,
  },
  watch: {},
  props: {
    tasks: Array,
  },
  data() {
    return {
      rules: {
        validDate: v => !v || /^\d{2}\/\d{2}\/\d{4}$/.test(v) || 'Ngày không hợp lệ',
      },
      title: '',
      creatorId: '',
      receiverId: '',
      status: '',
      dateFrom: '',
      dateTo: '',
      menuFrom: false,
      menuTo: false,
      isLoading: false,
      statusOptions: [
        { text: 'Chưa bắt đầu', value: 'not_started' },
        { text: 'Đang thực hiện', value: 'in_progress' },
        { text: 'Hoàn thành', value: 'completed' },
        { text: 'Chờ đánh giá', value: 'waiting' },
      ],
    }
  },
  methods: {
    applyFilters() {
      this.isLoading = true
      const data = {
        title: this.title,
        creatorId: this.creatorId,
        receiverId: this.receiverId,
        status: this.status,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
      }
      this.$nextTick(() => {
        this.$emit('onFilterChanged', data)
        this.isLoading = false
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
    margin-bottom: 25px;
  }
}
</style>
